import { useTranslation } from "react-i18next";
import { useActiveLang } from "../../domains/app/hooks/useActiveLang";
import { getRoomName } from "../../domains/room/hooks/useRoomName";
import type { PrivateRoom } from "../../domains/room/privateRoom";
import { getRoomLogoUrl } from "../../domains/room/utils/getRoomLogoUrl";
import { isB2bOrganisation } from "../../../../api/src/shared/domain/organisation";

/**
 * The room a resource is shared in, on its desktop page (a video, an
 * infographic): the room's logo and name, and in a partner's room the
 * partner's mention.
 */
export function DesktopRoomSource({
  room,
}: {
  room: PrivateRoom;
}): React.JSX.Element {
  const { t } = useTranslation();
  const { contentLang } = useActiveLang();
  const isPartnerRoom = isB2bOrganisation(room.organisationModel.id);
  return (
    <div className="flex items-center gap-2.5">
      <img
        src={getRoomLogoUrl(room)}
        alt=""
        className="size-8 shrink-0 rounded-full object-contain"
      />
      <div className="flex min-w-0 flex-col">
        <span className="truncate text-footnote font-semibold text-ds-black">
          {getRoomName(room, contentLang)}
        </span>
        {isPartnerRoom ? (
          <span className="text-desktop-meta text-ds-slate-600">
            {t("Shared by {{organisation}}", {
              organisation: room.organisationModel.name,
            })}
          </span>
        ) : null}
      </div>
    </div>
  );
}
